export const flowReviewZH = {
  flowReview1: '(作者)',
  flowReview2: '赞',
  flowReview3: '回复',
  flowReview4: '查看全部',
  flowReview5: '写下你的评论',
  flowReview6: '评论',
  flowReview7: '删除',
  flowReview8: '条回复'
}

export const flowReviewEN = {
  flowReview1: '(Author)',
  flowReview2: 'Like',
  flowReview3: 'Reply',
  flowReview4: 'View all ',
  flowReview5: 'Write your comment',
  flowReview6: 'Comments',
  flowReview7: 'Delete',
  flowReview8: 'replies'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/review.js